import { POPUP_ID } from './popup.constants';

export const showPopupAction =
  (popupId, popupOptions = {}) =>
  dispatch => {
    dispatch({ type: POPUP_ID, popupId, popupOptions });
  };
